import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import DashboardLayout from "../../layouts/DashboardLayout";
import ReferralQrDialog from "../../components/shared/ReferralQrDialog/ReferralQrDialog";
import { REFERRAL_ITEMS, buildReferralUrl, filterReferralItems } from "./constants/referralItems";
import { useThemeContext } from "../../../../contexts/ThemeContext/ThemeContext";
import localeText from "../../../../locale";
import "./EconomicCircleInvitePage.css";

const EconomicCircleInvitePage = ({ userInfo }) => {
  const username = userInfo?.username || localStorage.getItem("__extraconomy_username") || "";
  const { showInfoToast } = useToastContext();
  const { isSubnetLeader } = useThemeContext();
  const [qrVisible, setQrVisible] = useState(false);
  const [qrUrl, setQrUrl] = useState("");
  const [qrTitleKey, setQrTitleKey] = useState("");

  const userTypeInfo = userInfo?.plan || userInfo?.userTypeInfo || "";
  const visibleItems = filterReferralItems(REFERRAL_ITEMS, { userTypeInfo, isSubnetLeader });

  const inviteBase = "https://extraconomy.com";

  const openQrDialog = (url, localeKey) => {
    setQrUrl(url);
    setQrTitleKey(localeKey);
    setQrVisible(true);
  };

  const handleCopyLink = (referralUrl) => {
    if (JSON.parse(localStorage.getItem("__extraconomy_ismobile__") || "false")) {
      window.ReactNativeWebView?.postMessage?.(
        JSON.stringify({ content: referralUrl, clipboard: true }),
      );
    } else {
      navigator.clipboard?.writeText(referralUrl);
    }
    showInfoToast({ summary: "copied", detail: "copiedToClipboard" });
  };

  return (
    <DashboardLayout>
      <nav
        className="flex align-items-center gap-2 mb-2 text-sm"
        style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
        aria-label="Breadcrumb"
      >
        <Link to="/dashboard-economic-circle" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("economicCircle") || "Círculo Econômico"}
        </Link>
        <span>/</span>
        <span style={{ color: "var(--theme-text, #171717)" }}>
          {localeText("invite") || "Convite"}
        </span>
      </nav>

      <div className="mb-4">
        <h1 className="text-xl font-semibold m-0" style={{ color: "var(--theme-text, #171717)" }}>
          {localeText("invite") || "Convide"}
        </h1>
        <p className="text-sm m-0 mt-1" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {localeText("inviteSubtitle") || "Convide membros e expanda sua rede de influência."}
        </p>
      </div>

      <div className="grid economic-circle-invite-grid">
        {username ? (
          visibleItems.map((item) => {
            const referralUrl = buildReferralUrl(inviteBase, item, username);
            return (
              <div key={item.localeKey} className="col-12 sm:col-6 lg:col-4 xl:col-2">
                <div
                  className="border-round-md p-4 economic-circle-invite-card h-full flex flex-column align-items-center"
                  style={{
                    backgroundColor: "color-mix(in srgb, var(--theme-border) 10%, transparent)",
                  }}
                >
                  <Button
                    className="p-button-text p-0 mb-2 p-no-outline"
                    style={{ color: "var(--theme-text-muted)" }}
                    label={<i className="pi pi-qrcode text-6xl"></i>}
                    onClick={() => openQrDialog(referralUrl, item.localeKey)}
                    aria-label={`QR Code ${localeText(item.localeKey)}`}
                  />
                  <div
                    className="px-2 py-1 border-round text-xs font-medium mb-2"
                    style={{
                      backgroundColor: item.backgroundColor,
                      color: item.color,
                    }}
                  >
                    {localeText(item.localeKey)}
                  </div>
                  <div
                    className="text-xs text-center w-full truncate-text"
                    style={{ color: "var(--theme-text-muted)" }}
                  >
                    {referralUrl}
                  </div>
                  <Button
                    label={localeText("share") || "Compartilhar"}
                    size="small"
                    icon="pi pi-copy"
                    iconPos="right"
                    className="p-button-text border-round mt-2 p-no-outline"
                    style={{
                      color: "var(--theme-text-muted)",
                      border: "1px solid var(--theme-border)",
                    }}
                    onClick={() => handleCopyLink(referralUrl)}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-12">
            <p className="m-0" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("referralLinksExplanation") ||
                "Faça login para gerar links de indicação."}
            </p>
          </div>
        )}
      </div>

      <ReferralQrDialog
        visible={qrVisible}
        onHide={() => setQrVisible(false)}
        url={qrUrl}
        titleKey={qrTitleKey}
      />
    </DashboardLayout>
  );
};

export default EconomicCircleInvitePage;
